import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    data: "",
    RBF0405F40: {}, //자동이체등록내역조회 결과
    autoTrsaccTermi: {}, //자동이체 해지 데이터
    autoTrsaccUpdate: {}, //자동이체 변경 데이터
    RBF0605R60: {}, // 자동이체변경 예비거래 결과
  };
};

const autoTrsaccRegiHist = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default autoTrsaccRegiHist;
